import { useQuery } from "react-query";
import { getArea } from "../../../../../actions/Utilities/Area";

export default function useGetAreaOptions() {
  const { data } = useQuery("GetAreaOptions", getArea, {
    refetchOnWindowFocus: false,
  });
  return data;
}
